import script from "./CalendarMonth.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarMonth.vue?vue&type=script&setup=true&lang=js"

import "./CalendarMonth.vue?vue&type=style&index=0&id=8c896104&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c896104"]])

export default __exports__